import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  cloneScenario,
  fetchAllScenarios,
  fetchTypologies
} from '../../../../redux/actions/trm/trmDashboard';
import Summary from './Summary';
import { fetchTypologiesActions } from '../../../../redux/actions/common';

function mapStateToProps(state) {
  const { trmDashboard = {} } = state;
  const { allScenarios = {}, triggeredScenarioStatus = {} } = trmDashboard;
  const { isLoading, data, error } = allScenarios;
  return {
    isLoading,
    error,
    scenarios: data,
    triggeredScenarioStatus,
    authentication: state.authentication.data,
    trmActions: state.amlsCommon.commonTypologyAction
  };
}

function mapDispatchToProps(dispatch) {
  return {
    summaryAPIActions: bindActionCreators(
      { fetchAllScenarios, cloneScenario, fetchTypologiesActions },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Summary);
